import { createFeatureSelector, createSelector } from '@ngrx/store';

import { IMediaFilesViewState, MediaFilesViewType } from '../reducers/live-media-files-view.reducer';
import { liveFeatureKey, IState } from '../reducers/index';

const selectLiveState = createFeatureSelector<IState>(liveFeatureKey);

export const selectMediaFilesViewState = createSelector(selectLiveState, (state: IState) => state.mediaFilesView);

export const selectMediaFilesViewType = createSelector(selectMediaFilesViewState, (state: IMediaFilesViewState): MediaFilesViewType => state.view);
